export default ({
  namespaced: true,
  state: {
    view: 'plan',
    // type: 'index',
    value: {accesses: []}
  },
  getters: {
    value: state => {
      return state.value
    },
    accesses: state => {
      return state.value.accesses
    }
  },
  mutations: {
    change_value (state, payload) {
      Object.assign(state.value, payload)
    },
    change_accesses (state, payload) {
      Object.assign(state.value.accesses, payload)
    },
    reset_value (state) {
      Object.assign(state.value, {
        id_text: '',
        type: '',
        accesses: ''
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/plan.js